import React from 'react';

import { Users } from '../..';
import { Navigation } from '../../../utils/navigation';

export const ENT_Admins = (props) => (
  <Users title='Enterprise Admin' Navigation={Navigation()} addNewBtnTitle='Add New Admin' managedRole='Admin' {...props} />
);
